export default __webpack_public_path__ + "static/media/auto-drivetrain.4ce01b2b.svg";